import { AxiosResponse } from 'axios';
import { config } from 'config/config.local';
import {
  BasicResponse,
  ContentAccessMode,
  DeepTeams,
  GetTeams,
  GetTeamsParams,
  Team,
  TeamsParams,
} from 'contexts/teams/types';
import { BUSINESS_PYTHON } from './axios';

export const getTeams = (params?: GetTeamsParams): Promise<AxiosResponse<Team[]>> => {
  return BUSINESS_PYTHON.get(config.routes.teams.getTeams, { params });
};

export const createTeam = (data: Team): Promise<AxiosResponse<Team>> => {
  return BUSINESS_PYTHON.post(config.routes.teams.createTeams, { ...data });
};

export const updateTeam = (data: Team): Promise<AxiosResponse<Team>> => {
  return BUSINESS_PYTHON.put(`${config.routes.teams.createTeams}${data.id}/`, { ...data });
};

export const getPaginatedTeams = (params: TeamsParams): Promise<AxiosResponse<GetTeams>> => {
  return BUSINESS_PYTHON.get(config.routes.teams.getTeams, { params });
};

export const removeTeams = ({ ids }: { ids: string[] }): Promise<AxiosResponse<BasicResponse>> => {
  return BUSINESS_PYTHON.post(config.routes.teams.removeTeams, { teams_ids: ids });
};

export const getTeamData = ({ id }: { id: string }): Promise<AxiosResponse<DeepTeams>> => {
  return BUSINESS_PYTHON.get(config.routes.teams.getTeams + id + '/');
};

export const updateTeamContentAccess = ({
  id,
  content_access_mode,
}: {
  id: string;
  content_access_mode: ContentAccessMode;
}): Promise<AxiosResponse<{ team_id: string; content_access_mode: ContentAccessMode }>> => {
  return BUSINESS_PYTHON.patch(`${config.routes.teams.getTeams}${id}/content-access/`, {
    content_access_mode,
  });
};

export const batchUpdateTeamContentAccess = ({
  teams_ids,
  content_access_mode,
}: {
  teams_ids: string[];
  content_access_mode: ContentAccessMode;
}): Promise<AxiosResponse<{ team_id: string; content_access_mode: ContentAccessMode }[]>> => {
  return BUSINESS_PYTHON.post(`${config.routes.teams.getTeams}batch-content-access/`, {
    teams_ids,
    content_access_mode,
  });
};
